/** Keep portal privacy links usable without allowing executable URL schemes. */
export const normalizePrivacyUrl = (value: string | null | undefined): string | null => {
  const trimmed = value?.trim()

  if (!trimmed) return null

  try {
    const url = new URL(trimmed, "https://kehrblatt.invalid")

    return ["http:", "https:"].includes(url.protocol) ? trimmed : null
  } catch {
    return null
  }
}
